import { Component } from '@angular/core';

@Component({
  selector: 'cwt-app',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {
}
